import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

// Aplica máscara enquanto o usuário digita: até 11 dígitos vira CPF
// (000.000.000-00); a partir do 12º vira CNPJ (00.000.000/0000-00).
// Aceita até 14 dígitos (excedentes são descartados).
function mascaraCgc(valor) {
  const d = String(valor || '').replace(/\D/g, '').slice(0, 14);
  if (d.length <= 11) {
    return d
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
  }
  return d
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5');
}

export default function Login() {
  const [modo, setModo] = useState('cliente'); // 'cliente' | 'admin'
  const [username, setUsername] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setErro('');
    if (!username || !senha) return setErro('Preencha os campos');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { username, senha });
      login(data.token);
      const to = loc.state?.from?.pathname || '/home';
      navigate(to, { replace: true });
    } catch (err) {
      setErro(err.response?.data?.error || 'Falha ao entrar');
    } finally {
      setLoading(false);
    }
  };

  const esqueciSenha = async () => {
    const { value: ident } = await Swal.fire({
      title: 'Esqueci minha senha',
      input: 'text',
      inputLabel: 'Informe seu CPF ou CNPJ',
      inputPlaceholder: '000.000.000-00',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#2e9846',
      inputValidator: (v) => !v && 'Informe o identificador',
    });
    if (!ident) return;
    try {
      const { data } = await api.post('/auth/esqueci-senha', { identificador: ident });
      Swal.fire({ icon: 'success', title: 'Solicitação recebida', text: data.mensagem, confirmButtonColor: '#2e9846' });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Falha ao processar', confirmButtonColor: '#2e9846' });
    }
  };

  return (
    <div className="login-wrap-cli">
      <div className="login-card-cli">
        <div className="logo-cli">
          <img src={logo} alt="Centrão" />
        </div>
        <h1>Portal Clientes</h1>
        <p className="subtitulo">Centrão Materiais de Construção</p>

        <div className="toggle-modo-cli" role="tablist" aria-label="Tipo de acesso">
          <button
            type="button"
            className={modo === 'cliente' ? 'ativo' : ''}
            onClick={() => setModo('cliente')}
          >
            Cliente
          </button>
          <button
            type="button"
            className={modo === 'admin' ? 'ativo' : ''}
            onClick={() => setModo('admin')}
          >
            Admin
          </button>
        </div>

        <form onSubmit={submit}>
          {erro && <div className="erro-cli">{erro}</div>}

          <div style={{ marginBottom: 12 }}>
            <label className="label-cli">
              {modo === 'cliente' ? 'CPF / CNPJ' : 'Usuário'}
            </label>
            <input
              type="text"
              className="input-cli"
              value={username}
              onChange={(e) => setUsername(modo === 'cliente' ? mascaraCgc(e.target.value) : e.target.value)}
              placeholder={modo === 'cliente' ? '000.000.000-00' : 'seu.usuario'}
              inputMode={modo === 'cliente' ? 'numeric' : 'text'}
              maxLength={modo === 'cliente' ? 18 : undefined}
              autoFocus
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label className="label-cli">Senha</label>
            <input
              type="password"
              className="input-cli"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="••••••••"
            />
            {modo === 'cliente' && (
              <small style={{ color: 'var(--texto-suave)', display: 'block', marginTop: 6 }}>
                Primeira vez? Use os <strong>6 primeiros dígitos do seu CPF/CNPJ</strong>.
              </small>
            )}
          </div>

          <button type="submit" className="btn-verde-cli" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Entrando…' : 'Entrar'}
          </button>

          {modo === 'cliente' && (
            <div style={{ textAlign: 'center', marginTop: 14 }}>
              <button type="button" className="btn-ghost-cli" onClick={esqueciSenha}>
                Esqueci minha senha
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
